import { render, staticRenderFns } from "./brand-detail.vue?vue&type=template&id=d8f7972e&scoped=true&"
import script from "./brand-detail.vue?vue&type=script&lang=js&"
export * from "./brand-detail.vue?vue&type=script&lang=js&"
import style0 from "./brand-detail.vue?vue&type=style&index=0&id=d8f7972e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f7972e",
  null
  
)

export default component.exports